import { push } from './Actions/push';
import { close } from './Actions/close';
import { TActionsWithoutState } from '../Interfaces/TActionsWithoutState';
import { pushError } from './Actions/pushError';
import { pushSuccess } from './Actions/pushSuccess';

const actions = {
  close,
  push,
  pushError,
  pushSuccess
};

export type INotificationsActions = TActionsWithoutState<typeof actions>;

export default actions;
